var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-popup-content"},[_c(_vm.component,{tag:"component",attrs:{"title":_vm.sent ? '' : 'quote.login.title',"button-key":"start","phone-disabled":""},on:{"sent":_vm.nextView,"unsent":function($event){_vm.sent = false}},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }